function Publication() {
  return (
    
    <div className="">
       <p>раздел в разработке</p>
    </div>
  );
}

export default Publication;